import { z } from 'zod';

/**
 * Validates the browser-exposed Vite env at module load. Failing fast here
 * catches missing config in CI/build instead of a cryptic runtime error
 * inside the Supabase client. Mirrors `loadConfig` in Edge Functions
 * (see supabase/functions/_shared/env.ts).
 */
const envSchema = z.object({
  VITE_SUPABASE_URL: z.string().url('VITE_SUPABASE_URL must be a valid URL'),
  VITE_SUPABASE_ANON_KEY: z.string().min(20, 'VITE_SUPABASE_ANON_KEY missing or too short'),
  VITE_APP_ENV: z.enum(['development', 'staging', 'production']).default('development'),
  VITE_APP_NAME: z.string().default('Clinio'),
  VITE_APP_BASE_URL: z.string().url('VITE_APP_BASE_URL must be a valid URL'),
});

const parsed = envSchema.safeParse({
  VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
  VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
  VITE_APP_ENV: import.meta.env.VITE_APP_ENV,
  VITE_APP_NAME: import.meta.env.VITE_APP_NAME,
  VITE_APP_BASE_URL: import.meta.env.VITE_APP_BASE_URL,
});

if (!parsed.success) {
  const issues = parsed.error.issues.map((i) => `  - ${i.path.join('.')}: ${i.message}`).join('\n');
  throw new Error(`Invalid web environment:\n${issues}`);
}

export const env = parsed.data;

export const isProduction = env.VITE_APP_ENV === 'production';
export const isDevelopment = env.VITE_APP_ENV === 'development';
